var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 74,
    viewBox: "0 0 100 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 74,
    rx: 3,
    fill: "#888FA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3267 48.3288V41.6575L70 38.989V50.9973L59.3267 48.3288ZM49.9876 19C53.6689 19 56.6584 21.9897 56.6584 25.6712C56.6584 29.3528 53.6689 32.3425 49.9876 32.3425C46.3064 32.3425 43.3416 29.3528 43.3416 25.6712C43.3416 21.9897 46.3064 19 49.9876 19ZM36.6708 24.337C38.8697 24.337 40.6733 26.116 40.6733 28.3397C40.6733 30.5388 38.8697 32.3425 36.6708 32.3425C34.4472 32.3425 32.6683 30.5388 32.6683 28.3397C32.6683 26.116 34.4472 24.337 36.6708 24.337ZM34.0025 35.011H52.656C54.8548 35.011 56.6584 36.79 56.6584 38.989V50.9973C56.6584 53.1963 54.8548 55 52.656 55H34.0025C31.8036 55 30 53.1963 30 50.9973V38.989C30 36.79 31.8036 35.011 34.0025 35.011Z",
    fill: "#CDD1DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPreview);
export default __webpack_public_path__ + "static/media/video-preview.3c9279feeb8f05488274c2efc4ef9a45.svg";
export { ForwardRef as ReactComponent };